import classNames from 'classnames'
import { JSX } from 'react'

import { FormInput } from 'cng-common/features/form'
import { IFormInputProps } from 'cng-common/features/form/components/formInput/models'
import { createComponentFn } from 'onboarding/components/helpers/createComponentFn'
import themesStyles from 'onboarding/components/themes.module.scss'

type TComponentFn<T> = (props: IFormInputProps<T>) => JSX.Element | null

const applyDisabled = <T,>(component: TComponentFn<T>) => {
  return (props: IFormInputProps<T>) => {
    const { isDisabled, classes } = props
    const disabledTheme = isDisabled ? themesStyles.disabledInput : undefined

    return component({
      ...props,
      classes: { ...classes, root: classNames(classes?.root, disabledTheme) },
    })
  }
}

export const OnboardingFormInput = <T extends string | number>(props: IFormInputProps<T>) =>
  applyDisabled(createComponentFn<IFormInputProps<T> & JSX.IntrinsicAttributes>(FormInput))(props)
